export function stringifyProjectJson(value: unknown): string {
  return `${compactShortStringArrays(JSON.stringify(value, null, 2))}\n`
}

function compactShortStringArrays(json: string): string {
  return json.replace(
    /\[\n((?:[ \t]+"(?:[^"\\]|\\.)*",?\n)+)([ \t]*)\]/g,
    (match: string, entries: string) => {
      const values = entries
        .trim()
        .split('\n')
        .map((line) => line.trim())

      const inline = `[${values.map((entry) => entry.replace(/,$/, '')).join(', ')}]`
      return inline.length <= 70 ? inline : match
    }
  )
}
